// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleGatewayAgent = {
  id: "gateway-agent",
  mrn: "//iam.api.mondoo.app/roles/gateway-agent",
  title: "Gateway Agent",
  allowedActions,
} as const;

export type RoleGatewayAgent = typeof roleGatewayAgent;
